import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/schulenburg.pdf'; 
import { Helmet } from 'react-helmet';

function Page() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
		<var>Die mathematische schriften von Gottfried Wilheim Leibniz, vol. VII</var><br />
		C. I. Gerhardt (ed)<br />
		pp 242-243<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
		Date: 17 May 1698<br /><br />
        Translated from the Latin<br /><br /> 
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (11k)</Link>
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>Leibniz to Johann Christian Schulenburg (17 May 1698)</title>
            <meta name="description" content="An English translation of a LETTER TO JOHANN CHRISTIAN SCHULENBURG by Gottfried Wilhelm Leibniz, from 17 May 1698" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ TO JOHANN CHRISTIAN SCHULENBURG</h2>
                  {isMobile ? (
                    <>
                    {renderLinks()}  
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                 <br />
                [<b>GM VII p242</b>]<br /><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;There is no doubt that the Cartesians have exchanged the old prejudices for new ones. I definitely agree that all the specific phenomena of bodies happen by mechanical means, but the Cartesians have not sufficiently considered that the very origins of mechanics arise from a higher cause, although at the same time I will not agree with Malebranche, Sturm and other eminent men who believe that there is no power and action in matter. They have evidently not sufficiently considered what the nature of substance and value is, which God, who includes perpetual action in himself, has added to things. In my view there is a lot more to corporeal substance than extension and filling a place, for we must consider what it is that fills the place. Space, and also time, are nothing other than an order of possible existences, in space this existence is simultaneous, in time it is successive, and neither has a reality in itself outside of the divine immensity and eternity. I am certain that there is no vacuum. At the same time I ascribe to matter not only extension but also force and effort. And other things of much greater importance lie hidden in these things. I admit that intervening vacua once satisfied me, though today I think the opposite, although as I have said I do not locate the nature of matter in extension. I also think I have shown that what they say is not true, that a body gives to another body that quantity of motion that it loses. Yet I have discovered the truth about motive power. And power is certainly something real, but motion never exists, since complete motion never exists any more than complete time. What the union of the soul and the body and the commerce of different substances consists of is a problem that I believe I have solved. Sometime I will add more on this. And I wanted to add a few remarks to your dissertations, adding this one point: I also agree that the cause of parhelia is the intersection of haloes, as suggested by Gassendi. [<b>GM VII p243</b>] And I think it will be apparent, when Huygen's <var>Dioptrics</var>, a posthumous work, is published, that in explaining the cause of parhelia, Descartes was not correct.
        <br /><br /><br />
                &#169; Lloyd Strickland 2005<br />
                With gratitude to John Thorley for advice and suggestions
                <br></br><br></br>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Page;
